import { SharingTipId } from '../../types/sharingTipId';
import { isFeatureEnabled } from 'owa-feature-flags';
import { assertNever } from 'owa-assert';

export function isSharingTipEnabled(sharingTipId: SharingTipId): boolean {
    switch (sharingTipId) {
        case SharingTipId.noPermissionToShare:
        case SharingTipId.noPermissionToShareExternally:
        case SharingTipId.externalRecipientCSL:
        case SharingTipId.noPermissionSet:
        case SharingTipId.sharingWithLargeDL:
        case SharingTipId.linkWillExpire:
        case SharingTipId.linkHasExpired:
            return true;
        case SharingTipId.getSharingInfoFailed:
            return isFeatureEnabled('doc-attachment-sharingInfoFailureTip');
        default:
            return assertNever(sharingTipId);
    }
}
